import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Login from '../app/views/Login/Login';
import Dashboard from '../app/views/Dashboard/Dashboard';
import Models from '../app/views/Models/Models';
import Fantasy from '../app/views/Fantasy/Fantasy';
import Casting from '../app/views/Casting/Casting';
import Contact from '../app/views/Contact/Contact';
import Users from '../app/views/Users/Users';
import TrashBin from '../app/views/TrashBin/TrashBin';
import ModelEdit from '../app/views/ModelEdit/ModelEdit';
import { Auth } from './Auth';

const ProtectedRoute = ({ children }) => {
    return Auth() ? children : <Navigate to="/login" />;
}

const AppRoutes = () => {
    return (
        <Router>
            <Routes>
                <Route path="/login" element={Auth() ? <Navigate to="/" /> : <Login />} />
                <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                <Route path="/models" element={<ProtectedRoute><Models /></ProtectedRoute>} />
                <Route path="/fantasy" element={<ProtectedRoute><Fantasy /></ProtectedRoute>} />
                <Route path="/casting" element={<ProtectedRoute><Casting /></ProtectedRoute>} />
                <Route path="/contact" element={<ProtectedRoute><Contact /></ProtectedRoute>} />
                <Route path="/users" element={<ProtectedRoute><Users /></ProtectedRoute>} />
                <Route path="/trash" element={<ProtectedRoute><TrashBin /></ProtectedRoute>} />
                <Route path="/model-edit/:id" element={<ProtectedRoute><ModelEdit /></ProtectedRoute>} />
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </Router>
    )
}

export default AppRoutes;
